<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="users"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :sort="sort"
      :hasMore.sync="hasMore"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Пользователи</h1>
        <btn-filters
          :data="data"
          endpoint="users"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @sort-change="sortChange"
        @load-more="$refs.data.loadMore"
      >
        <el-table-column sortable="keyword" prop="second_name" label="Фамилия"></el-table-column>
        <el-table-column sortable="keyword" prop="first_name" label="Имя"></el-table-column>
        <el-table-column sortable="keyword" prop="third_name" label="Отчество"></el-table-column>
        <el-table-column sortable="keyword" prop="role.label" label="Роль"/>
        <el-table-column sortable="keyword" prop="email" label="E-mail"/>
        <el-table-column sortable="keyword" prop="phone" label="Телефон"/>
        <el-table-column sortable="keyword" prop="division.name" label="Подразделение"/>
        <el-table-column sortable="keyword" prop="division.region.name" label="Организация"/>
        <table-column-date sortable="custom" prop="last_activity_at" label="Последний сеанс" from-now width=""/>
        <el-table-column align="center">
          <template slot-scope="{row}">
            <btn-action class="btn btn-sm btn-outline-danger" @click="() => resendPassword(row.id, row.email)">Сбросить пароль</btn-action>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    metaInfo: {title: 'Пользователи'},
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        sort: null,
        hasMore: true,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const keyword = sort.column.sortable === 'keyword' ? '.keyword' : ''
          this.sort = `${sort.prop + keyword}:${order}`
        } else {
          this.sort = null
        }
      },
      resendPassword (id, email) {
        if (window.confirm(`Сбросить пароль для ${email}?`)) {
          return api.put(`auth/resend/${id}`)
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/users.vue